import React from 'react'
import { string } from 'prop-types'

function Image({ src, alt, className }) {
  const style = `${className} lazyload`

  return <img className={style} data-src={src} alt={alt} />
}

Image.propTypes = {
  src: string.isRequired,
  alt: string.isRequired,
  className: string.isRequired,
}

export default Image
